export const hasPermission = (permissions, permission) => {
    if(!permissions) return false;
    return permissions.indexOf(permission) >= 0;
}


// WEBPACK FOOTER //
// ./src/utils/permissions.js